export type ReasoningTextPart = {
	type: string
	text?: unknown
	content?: unknown
}

export const getReasoningText = (part: ReasoningTextPart): string => {
	const rawText = part.text ?? part.content ?? ''
	return typeof rawText === 'string' ? rawText : String(rawText)
}
